/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiRatingWithProfileInfoAndLevel {
    'profile_id': string;
    'handle': string;
    'wallets': Array<string>;
    'tdh': number;
    'xtdh': number;
    'rating': number;
    'cic': number;
    'last_modified': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "profile_id",
            "baseName": "profile_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "handle",
            "baseName": "handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "wallets",
            "baseName": "wallets",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "float"
        },
        {
            "name": "rating",
            "baseName": "rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cic",
            "baseName": "cic",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "last_modified",
            "baseName": "last_modified",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiRatingWithProfileInfoAndLevel.attributeTypeMap;
    }

    public constructor() {
    }
}
